import {CsvImport} from 'organization/Event/Integrations/CsvImport/CsvImportProvider'
import {useI18n} from 'i18n/I18nContext'
import {appLocaleToBcp47} from 'i18n/locales'
import React from 'react'
import styled from 'styled-components'

export const ImportHistory = (props: {imports: CsvImport[]}) => {
  const {imports} = props
  const {t, locale} = useI18n()
  const dateLocale = appLocaleToBcp47(locale)

  return (
    <InfoSection>
      <ImportsSection>
        <h4>{t('orgCsvHistory.title')}</h4>

        <div className="attendant__wrapper mb-35">
          <table>
            <thead>
              <tr>
                <th>{t('orgCsvHistory.thFile')}</th>
                <th>{t('orgCsvHistory.thStatus')}</th>
                <th>{t('orgCsvHistory.thTotal')}</th>
                <th>{t('orgCsvHistory.thImported')}</th>
                <th>{t('orgCsvHistory.thErrors')}</th>
                <th>{t('orgCsvHistory.thDate')}</th>
              </tr>
            </thead>
            <tbody>
              {imports.map((importItem) => (
                <tr key={importItem.id}>
                  <td>{importItem.file}</td>
                  <td>
                    {importItem.status}{' '}
                    {importItem.message && (
                      <>
                        {' '}
                        <br />
                        <i>{importItem.message}</i>
                      </>
                    )}
                  </td>
                  <td>{importItem.total}</td>
                  <td>{importItem.imported}</td>
                  <td>{importItem.fails}</td>
                  <td>
                    {new Date(importItem.created_at).toLocaleDateString(
                      dateLocale,
                    )}
                  </td>
                </tr>
              ))}
              {imports.length === 0 && (
                <tr>
                  <td colSpan={6}>{t('orgCsvHistory.empty')}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </ImportsSection>
    </InfoSection>
  )
}

const ImportsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const InfoSection = styled.div`
  margin-top: 30px;
  background: #f8f9fa;
  padding: 20px;
  border-radius: 10px;

  h3 {
    margin-bottom: 10px;
    color: #202124;
  }
  p {
    margin-bottom: 12px;
    color: #3c4043;
  }
  ul {
    list-style: disc;
    padding-left: 20px;
    li {
      margin-bottom: 6px;
      color: #5f6368;
    }
  }
`
